import React from 'react';
import { Field } from 'redux-form';
import { Button } from 'antd';
import { SelectField } from 'redux-form-antd';

const alcoholOptions = [
  {
    label: 'Alcohol Targeted Apps Only',
    value: 'is_alcohol',
  },
  {
    label: 'inBar Apps Only',
    value: 'is_inbar',
  },
  {
    label: 'Age 18+?',
    value: 'over18',
  },
  {
    label: 'Age 21+?',
    value: 'over21',
  },
];

const formItemLayout = {
  colon: false,
  labelCol: {
    xs: { span: 8 },
    sm: { span: 8 },
  },
  wrapperCol: {
    xs: { span: 8 },
    sm: { span: 8 },
  },
};

const AlcoholTab = ({ handleSubmit, submitting }) => (
  <div>
    <form onSubmit={handleSubmit}>
      <Field
        {...formItemLayout}
        name="alcohol"
        id="alcohol"
        options={alcoholOptions}
        mode="multiple"
        component={SelectField}
      />
      <Button onClick={handleSubmit} loading={submitting}>
        Save
      </Button>
    </form>
  </div>
);

export { alcoholOptions };

export default AlcoholTab;
